// Add this check as early as possible in your script

/*document.dispatchEvent( new CustomEvent('gtmIsLoaded', {
  detail: {
    title: 'Speicher- und Tracking-Einstellungen',
    description: 'Wir verwenden Cookies und andere Speichertechnologien, um Ihnen das bestmögliche Web-Erlebnis zu bieten. Dies ermöglicht es uns auch, das Nutzerverhalten zu analysieren und die Website für Sie stetig zu verbessern.',
    privacyUrl: 'https://staging.ewl-luzern.ch/datenschutzerklaerung/#cookie',
    rejectAll: 'Ablehnen',
    settings: 'Einstellungen',
    confirm: 'Bestätigen'
  }
}) )*/

console.log('Cookie banner');

function shouldShowBanner() {
  try {
    const consentMode = JSON.parse(localStorage.getItem('consentMode')) ?? {};
    return !('ad_user_data' in consentMode && 'ad_personalization' in consentMode);
  } catch (e) {
    return true; // Show banner if there's any error parsing localStorage
  }
}

function removeCookieBanner() {
  document.documentElement.classList.add('has-cookie-consent');
  const cookieBanner = document.querySelector('#cookie-consent');
  if (cookieBanner) {
    cookieBanner.remove();
  }
}

// Prevent banner flash by adding a style tag early
if (!shouldShowBanner()) {
  removeCookieBanner()
}


// sometimes, the gtm can be faster than the whole content-load, so check for both events!
const WaitForDom = new Promise((resolve) => {
    window.addEventListener("DOMContentLoaded", resolve);
  });
  const WaitForGtm = new Promise((resolve) => {
    // dispatch the event for the document OR configure it bubbling
    document.addEventListener('gtmIsLoaded', (e) => resolve(e));
  });
  
  Promise
    .all([WaitForDom, WaitForGtm])
    .then(([_, evt]) => {
      const cookieMarkerContent = evt.detail
  
      const cookieBannerMarkup = `<div id="cookie-consent" class="cookie-banner">
        <div class="cookie-banner__container">
            <div class="cookie-banner__text">
                <p class="cookie-banner__title">${cookieMarkerContent.title}</p>
                <p class="cookie-banner__desc">${cookieMarkerContent.description}</p>
            </div>
            <div class="cookie-banner__cta">
              <a 
                  href="${cookieMarkerContent.privacyUrl}"
                  class="cookie-banner__settings"
              >
                  ${cookieMarkerContent.settings}
              </a>
              <button id="btn-accept-all" class="cookie-banner__button">
                ${cookieMarkerContent.confirm}
              </button>
            </div>
          </div>
      </div>`;

      const consentMode = JSON.parse(localStorage.getItem("consentMode")) ?? {}

      if (shouldShowBanner()) {
        if (! document.querySelector('.cookie-banner__button') ) {
          document.body.insertAdjacentHTML("afterbegin", cookieBannerMarkup);
        }
  
        document.querySelector('.cookie-banner__button').focus()
  
        try {
          window.dataLayer.push({
            event: "cookieBarIsDisplaying",
          });
        } catch (e) {
          console.error('No datalayer')
        }
  
      } else {
        try {
          window.dataLayer.push({
            event: "consentAlreadyGiven",
          });
        } catch (e) {
          console.error('No datalayer')
        }
      }
    })